__turbopack_context__.v({
  "toggleIcon": "IdentityVerificationDialog-module__MPFXjG__toggleIcon",
});
